import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import couterpart from 'counterpart';
import {ToastsContainer, ToastsStore} from 'react-toasts';

import AuthenticationService from '../services/AuthenticationService';
import MenuComponent2 from './MenuComponent2';
import ItemButtons from './ItemButtons';
// import ReactTablePagination from './PaginationComponent';
import ItemDataService from '../services/ItemDataService';
import "../css/style.css";
import {MdDeleteForever, MdModeEdit} from 'react-icons/md';
import { FaFilter, FaRegSave } from 'react-icons/fa';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import {IoIosAddCircleOutline} from 'react-icons/io';
import UserDataService from '../services/UserDataService';
import ShopDataService from '../services/ShopDataService';

import { ICON_COLOR } from '../icon';

class ItemMappingList extends Component {
  constructor () {
    super();

    this.state = {
      selectOptions: [],
      items: [],
      itemmappings: [],
      shops: [],
      columns : [
        {
          id: "idx",
          accessor: "",
          width: 40,
          Cell: row =>(
            <div style={{ padding: "10px"}}>{row.index + 1}</div>
          )
        },        
        {
            Header: couterpart.translate('item_assigned_to'),
            accessor: 'userName'
        },{
            Header: couterpart.translate('item_shop'),
            accessor: 'store'
        },{
            Header: couterpart.translate('item_sku'),
            accessor: 'sku'                     
        },{          
            Header: couterpart.translate('action'),
            accessor: 'action',
            width: 300,
            Cell: row =>(
              this.getFunctionButtons(row)
            )
      }],
      id: 0,
      store: '',
      sku: '',
      userName: ''
    };
  }

  getFunctionButtons(row){
      if (AuthenticationService.isAdmin() || AuthenticationService.isService()){
        const button_edit = couterpart.translate('button_edit');
        const button_delete = couterpart.translate('button_delete');
        return (
          <div style={{ textAlign: "center" }}>
          <button className="myButton" onClick={() => this.handleEdit(row.original)}>
          <MdDeleteForever color={ICON_COLOR}/>&nbsp;
          {button_edit}</button>&nbsp;
          <button className="myButton" onClick={() => this.handleDelete(row.original)}>
          <MdModeEdit color={ICON_COLOR}/>&nbsp;
          {button_delete}</button>
        </div>
        )
      }else{
        return (<div>&nbsp;</div>)
      }
  }

  componentDidMount () {
    this.loadItems()

    ShopDataService.retrieveShops().then(data => {
        if (data.message === undefined){
            let filteredShop = this.filterShop(data);
            this.setState({ shops:  filteredShop})
        }else{
            this.setState({ shops:  []})
        }
    });
    
    UserDataService.retrieveUsers().then(data => {
        var len = data.length;
        var selectOptions = [];
        for(var i=0; i<len; i++){
            if ((data[i].roleName === 'DESIGNER')){
                selectOptions.push({id:data[i].id, label: data[i].userName, value: data[i].userName, role: data[i].roleName})
            }
        }
        this.setState({selectOptions: selectOptions});
    });
        
    let searchValue = WorkOrderUtil.getItem('items.searchValue') ? WorkOrderUtil.getItem('items.searchValue') : ''

    if (AuthenticationService.isAdmin()){
      ItemDataService.retrieveItemMappingsBy(searchValue).then(data => {
        if (data.message === undefined){
          this.setState({ itemmappings:  data, searchValue: searchValue})
        }else{
          this.setState({ itemmappings:  [], searchValue: searchValue})
          ToastsStore.error(data.message);
        }
      });
    } else {
      ItemDataService.retrieveItemMappingsByShopAndBy(searchValue).then(data => {
        if (data.message === undefined){
          this.setState({ itemmappings:  data, searchValue: searchValue})
        }else{
          this.setState({ itemmappings:  [], searchValue: searchValue})
          ToastsStore.error(data.message);
        }
      });
    }
      
  }

  filterShop(data){
    if (AuthenticationService.isAdmin()){
      return data;
    }

    if (this.isLimitedUser() === false){//2: limited user, 1: unlimited user
      return data;
    }

    const workingShop = sessionStorage.getItem('workingShop');
    return data.filter(sh => {
      return sh.name === workingShop;
    });
  }

  isLimitedUser(){
    const limitUser = sessionStorage.getItem('limitUser');
    console.log(limitUser);
    if (limitUser !== '2'){//2: limited user, 1: unlimited user
      return false;
    }
    return true;
  }  

  handleView(e){
    this.props.history.push("/items/view/" + e.id);
  }

  // handleEdit(e){
  //   this.props.history.push("/items/edit/" + e.id);
  // }  

  handleDelete(e){
    console.log('handle delete item map', e)
    ItemDataService.deleteItemMapping(e.id).then(data => {
      if (data.message === undefined){
        if (AuthenticationService.isAdmin()){
          ItemDataService.retrieveItemMappingsBy('').then(data => {
            this.setState({ itemmappings:  data})
          });
        } else {
          ItemDataService.retrieveItemMappingsByShopAndBy('').then(data => {
            this.setState({ itemmappings:  data})
          });
        }
      }
    });
  }

  handleChange(e){
    var value = e.target.value;
    sessionStorage.setItem("items.searchValue", value)
    if (value === undefined || value.length < 1){
      this.setState({                 
        searchValue: ''                   
      });
    }
    else {
      this.setState(prevState => ({                 
        searchValue: value                   
      }));
    }
  }

  onFilter(e){
    if (AuthenticationService.isAdmin()){
      ItemDataService.retrieveItemMappingsBy(this.state.searchValue).then(data => {
        if (data.message === undefined){
          this.setState({ itemmappings:  data})
        }else{
          this.setState({ itemmappings:  []})
          ToastsStore.error(data.message);
        }
      });
    } else {
      ItemDataService.retrieveItemMappingsByShopAndBy(this.state.searchValue).then(data => {
        if (data.message === undefined){
          this.setState({ itemmappings:  data})
        }else{
          this.setState({ itemmappings:  []})
          ToastsStore.error(data.message);
        }
      });
    }
  }


    handleEdit(row){
      console.log(row)
        this.setState({
            id: row.id,
            store: row.store,
            sku: row.sku,
            userName: row.userName
        });
    }

    handleSelectChange(e){
        var name = e.target.name;
        var value = e.target.value;
        this.setState({ [name]:  value});
    }    

    handleNew(e){
      this.setState({
          id: 0,
          store: '',
          sku: '',
          userName: ''
      });
    }

    handleSave(){
      let vm = this;
      var msg = "";
      if (this.state.store === undefined || this.state.store.trim().length < 1){
          ToastsStore.error(couterpart.translate('msg_store_missing'));
          return;
      }

      if (this.state.sku === undefined || this.state.sku.trim().length < 1){
          ToastsStore.error(couterpart.translate('msg_sku_missing'));
          return;
      }

      if (this.state.userName === undefined || this.state.userName.trim().length < 1){
          ToastsStore.error(couterpart.translate('msg_username_missing'));
          return;
      }     

      if ((this.state.id != null) && (this.state.id > 0)){
          ItemDataService.updateItemMapping(this.state).then(data => {
              if (data.id !== undefined && data.id > 0){
                msg = couterpart.translate("msg_item_mapping_ok");
              } else {
                msg = couterpart.translate("msg_saved_error");
              }
              ToastsStore.info(msg);
              vm.onFilter();
          });
      }else{
        ItemDataService.saveItemMapping(this.state).then(data => {
            if (data.id !== undefined && data.id > 0){
              msg = couterpart.translate("msg_item_mapping_ok");
            } else {
              msg = couterpart.translate("msg_saved_error");
            }
            ToastsStore.info(msg);
            vm.onFilter()
        });
      }
    }

    loadItems(){
      console.log('limited: ' + this.isLimitedUser());
      if (AuthenticationService.isAdmin() || (this.isLimitedUser() === false)){
        ItemDataService.retrieveItems().then(data =>{
            this.setState({ 
                items: data
            });
        });
      } else {
        ItemDataService.retrieveByShopAndBy(undefined).then(data =>{
          console.log(data);
          this.setState({ 
              items: data
          });
        });
      }
    }

    handleItemChange(e){
      var newValue = e.target.value;
      this.setState({                 
        sku: newValue,              
      });   
    }    

    renderItemList(){
        let options = this.state.items !== undefined?  this.state.items : []
        return(
            <div>
                <input type="text" name="font" size="16" className="selectBox3"
                    list="skus"
                    defaultValue={this.state.sku}
                    onChange={this.handleItemChange.bind(this)}/>
                <datalist id="skus">
                    { options.map(x => <option value={x.sku} key={x.sku}>{x.sku}</option>) }
                </datalist>
            </div>          
        );         
        // return(
        //   <select className="selectBox3" value={this.state.sku}  onChange={this.handleSelectChange.bind(this)} name="sku">
        //       <option key="empty" value=""></option>
        //       {options.map(option =>this.renderSkuOption(option))}
        //   </select>          
        // );        
    }

    renderShopList(){
        let options = this.state.shops !== undefined?  this.state.shops : []
        return(
          <select className="selectBox3" value={this.state.store} onChange={this.handleSelectChange.bind(this)} name="store">
              <option key="empty" value=""></option>
              {options.map(option =>this.renderShopOption(option))}
          </select>          
        );        
    }    

    renderShopOption(option){
        return (
            <option key={option.name} value={option.name}>{ option.name }</option>
        );
    }      

    renderSkuOption(option){
        return (
            <option key={option.sku} value={option.sku}>{ option.sku }</option>
        );
    }    

    renderOption(option){
        return (
            <option key={option.value} value={option.value}>{ option.label }</option>
        );
    }     

    renderUserSelection(){
        let options = this.state.selectOptions !== undefined?  this.state.selectOptions : []
        console.log('renderUserSelection', options)
        return(
            <select className="selectBox3" value={this.state.userName} onChange={this.handleSelectChange.bind(this)} name="userName">
                <option key="empty" value=""></option>
                {options.map(option =>this.renderOption(option))}
            </select>
        );
    }     

  render() {
    if (!AuthenticationService.isAdmin() && !AuthenticationService.isService()){
      return (<div>Unauthorized access.</div>);
    }
    return (
          <div>
              <MenuComponent2/>
              <ToastsContainer store={ToastsStore} position="bottom_center" />
              <div style={{padding:"5px"}}>
                <div>ID: </div>
                <div>
                    {this.state.id}
                </div>                 
                <div>{couterpart.translate('item_shop')}: </div>
                <div>
                    {this.renderShopList()}
                </div>                
                <div>{couterpart.translate('item_sku')}: </div>
                <div>
                    {this.renderItemList()}
                </div>
                <div>{couterpart.translate('item_assigned_to')}: </div>
                <div>
                    {this.renderUserSelection()}
                </div>
                <div>
                    <button  className="myButton" onClick={this.handleNew.bind(this)}>
                        <IoIosAddCircleOutline color={ICON_COLOR}/>{couterpart.translate('ResetToNew') }
                    </button>&nbsp;&nbsp;
                    <button  className="myButton" onClick={this.handleSave.bind(this)}>
                        <FaRegSave color={ICON_COLOR}/>{couterpart.translate('button_save')}
                    </button>
                </div>
                <hr/>                
              <ItemButtons/>
              </div>
              <div>
                <input type="text" defaultValue={this.state.searchValue} size="40"
                  placeholder={couterpart.translate('item_sku')}
                  onChange={this.handleChange.bind(this)}/>
                &nbsp;&nbsp;
                <button className="myButton" 
                onClick={this.onFilter.bind(this)}>
                <FaFilter color={ICON_COLOR}/>
                &nbsp;{couterpart.translate('button_filter')}</button>
              </div>
              <ReactTable
                NoDataComponent={() => null} 
                // PaginationComponent={ReactTablePagination}
                previousText={"<"}
                nextText={">"}
                data={this.state.itemmappings}
                columns={this.state.columns}
                defaultPageSize = {10}
                showPageSizeOptions = {true}
                pageSizeOptions = {[3, 5, 10, 20]}
                getTrProps={(state, rowInfo, column) => { 
                  if (rowInfo && rowInfo.row) {
                  return {
                    onClick: (e) => {
                      this.setState({
                        selected: rowInfo.index,
                        itemId: rowInfo.original.id
                      })
                    },
                    style: {
                      background: rowInfo.index === this.state.selected ? '#DCDCDC' : 'white',
                      color: rowInfo.index === this.state.selected ? 'white' : 'black'
                    }
                  }
                  }else{
                    return {}
                  }
                }
              }
              />
          </div>      
    )
  }
}

export default ItemMappingList;